
//Uninor + Rsh Function
// function ConfigUrl(type) {
//     if (type === 'apiUrl') {
//         let response = "https://www.uninor.app/playdiator/";
//         return response;
//     }
//     if (type === 'videoUrl') {
//         let response = "http://206.189.140.252/vod/";
//         return response;
//     }
// }
//Live Function
function ConfigUrl(type) {
    if (type === 'apiUrl') {
        let response = "https://www.playdiator.com/apis/";
        return response;
    }
    if (type === 'videoUrl') {
        let response = "https://www.playdiator.com/vod/";
        return response;
    }
}

export default ConfigUrl;
